
import { Observable } from 'rxjs';

import { EuTreeNode } from "./tree.def";

export abstract class EuTreeService {

    constructor(public http: any) { }

    abstract getTreeNodes(url: string, node?: EuTreeNode, cond?: Object): Promise<EuTreeNode[]>

    abstract getTreeNodesOb(url: string, node?: EuTreeNode, cond?: Object): Observable<EuTreeNode[]>

}